export default {
    newDesign: true,
    slotFirst: true,
    parameters: {
        landing_id: "ItQPsFSl",
        segment: 9,
        success_page: "it_thankyou_page_fwd",
    },
    title:
        "Scopri il corso perfetto per tuo figlio in 1 minuto | Kodland",
    downtimeUrl: "https://www.kodland.org/it",
    startPage: {
        title:
            "Creiamo un percorso di apprendimento personalizzato per tuo figlio",
        subtitle:
            "Rispondi a poche domande rapide: ti consiglieremo il corso piu adatto e ti mostreremo quali competenze tuo figlio potra sviluppare.",
        leftSide: {
            title: "Corso gratuito di creativita digitale o modellazione 3D per bambini/e e ragazzi/e",
        },
        image: {
            url: "/welcome/it_personalized_quiz_fwd_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/it_personalized_quiz_fwd_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Scopri il corso giusto 🚀",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Grazie per aver scelto la nostra piattaforma educativa!",
        subtitle:
            "Si prega di notare che i nostri corsi richiedono una tastiera e un mouse; quindi telefoni, tablet e dispositivi privi di queste caratteristiche non sono compatibili. Per rimanere sempre aggiornato/a sulle nostre novita, puoi seguirci su <a href=\"https://www.instagram.com/kodland.it/\" target=\"_blank\">Instagram</a>",
    },
    quizRotateBySteps: {
        1: {
            title: "Quanti anni ha tuo figlio?",
            type: "age",
            button: "",
        },
        2: {
            question:
                "Quanto tempo tuo figlio trascorre sui dispositivi (telefono, computer o tablet)?",
            answers: [
                "Meno di 1 ora al giorno",
                "Da 1 a 4 ore al giorno",
                "Piu di 4 ore al giorno",
            ],
        },
        3: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/turkey_longquiz_softskills_4.webp",
            subtitle:
                "Cosa aspetta tuo figlio nelle lezioni?<br>✅ Provera la creativita digitale: animazione, illustrazione, modellazione 3D, design<br>✅ Creera i suoi primi progetti (collage, sito web, visualizzazione 3D di un intero mondo e la sua animazione per futuri cartoni animati e giochi, ecc.)<br>✅ Imparera strumenti utili per creare opere d'arte digitali",
            button: "Eccellente!",
        },
        4: {
            question:
                "Tuo figlio ha accesso a un laptop o a un PC desktop per studiare?",
            answers: [
                "Si, ha il proprio dispositivo 💻✅",
                "Si, ma lo condivide con altri 🖥️👫",
                {
                    answer: "No, non ha accesso regolare 🚫",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            question: "Cosa piace di piu creare a tuo figlio?",
            answers: [
                "🎨 Disegnare personaggi e illustrazioni",
                "🎬 Creare animazioni e brevi video",
                "🖌 Creare poster, copertine e adesivi",
                "🧱 Creare oggetti e mondi in 3D",
            ],
        },
        6: {
            question: "In che modo tuo figlio preferisce lavorare?",
            answers: [
                "🌈 Inventare idee e uno stile visivo",
                "✏️ Lavorare con colori e disegno",
                "👥 Creare progetti insieme ad altri bambini",
                "📐 Costruire oggetti tridimensionali in 3D",
            ],
        },
        7: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
                "Offriamo sia format di apprendimento individuali che di gruppo, e teniamo conto dell'eta dei bambini per adattare il processo a ciascun bambino nel miglior modo possibile.",
            button: "Andiamo!",
        },
        8: {
            question:
                "Quale formato di apprendimento e piu adatto a lui?",
            answers: [
                "🚀 Provare diversi tipi di creativita",
                "🎨 Imparare design, disegno e animazione",
                "🧠 Imparare attraverso attivita creative",
                "🎮 Approfondire il 3D e software piu avanzati",
            ],
        },
        9: {
            typeInfo: "loaderScreen",
            sliderImages: [
                "/welcome/it_personalized_quiz_fwd_r1_desk.png",
                "/welcome/it_personalized_quiz_fwd_r2_desk.png",
                "/welcome/it_personalized_quiz_fwd_r3_desk.png",
            ],
            sliderImagesMobile: [
                "/welcome/it_personalized_quiz_fwd_r1_mob.png",
                "/welcome/it_personalized_quiz_fwd_r2_mob.png",
                "/welcome/it_personalized_quiz_fwd_r3_mob.png",
            ],
            duration: 5000,
            textLoader: "Stiamo analizzando le tue risposte per trovare il corso migliore…",
            titleLoader: "Analizziamo le tue risposte per scegliere il corso e l'insegnante ideali",
            subtitleLoader: "⭐ 4,8 / 5 — basato su oltre 50.000 recensioni",
        },
        10: {
            dynamicTypeInfo: [
                {
                    condition: [
                        {
                            step: 5,
                            answer: "🧱 Creare oggetti e mondi in 3D",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/it_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Entra nel mondo del 3D | Kodland",
                        subtitle:
                            "Impara a creare oggetti e mondi tridimensionali con strumenti professionali e porta la tua creatività oltre lo schermo.",
                        button: "👉 Iscriviti ora",
                    },
                },
                {
                    condition: [
                        {
                            step: 6,
                            answer: "📐 Costruire oggetti tridimensionali in 3D",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/it_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Entra nel mondo del 3D | Kodland",
                        subtitle:
                            "Impara a creare oggetti e mondi tridimensionali con strumenti professionali e porta la tua creatività oltre lo schermo.",
                        button: "👉 Iscriviti ora",
                    },
                },
                {
                    condition: [
                        {
                            step: 8,
                            answer: "🎮 Approfondire il 3D e software piu avanzati",
                        },
                    ],
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/it_personalized_quiz_fwd_final_modeling.png",
                        title: "🧱 Entra nel mondo del 3D | Kodland",
                        subtitle:
                            "Impara a creare oggetti e mondi tridimensionali con strumenti professionali e porta la tua creatività oltre lo schermo.",
                        button: "👉 Iscriviti ora",
                    },
                },
                {
                    default: true,
                    data: {
                        typeInfo: "noQuestions",
                        imageLink: "/welcome/it_personalized_quiz_fwd_final_creativity.png",
                        title: "🧩 Porta la creatività al livello successivo | Kodland",
                        subtitle:
                            "Design, illustrazione e animazione in un unico corso — per trasformare le idee in progetti digitali unici.",
                        button: "👉 Iscriviti ora",
                    },
                },
            ],
        },
        11: {
            title:
                "Quando vuoi che tu e tuo/a figlio/a facciate la prima lezione gratuita insieme?",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        12: {
            title: "Completa i tuoi dettagli di contatto per accedere al corso gratuito",
            type: "one-page-contacts",
            subtitle: "",
            button: "Quasi fatto 🔥",
        },
        13: {
            title:
                "Controlla questi dettagli per completare la registrazione ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Ti ricordiamo che per la lezione avrai bisogno di un PC o laptop funzionante e che dovrai accompagnare tuo figlio per tutta la lezione. Ricorda che è individuale e personalizzato.",
            button: "Cos'altro?",
        },
        14: {
            title: "Controlla la tua email e WhatsApp prima della lezione di prova 📞",
            typeInfo: "whatsapp",
            subtitle:
                "24 ore prima della lezione ti invieremo un promemoria e 2 ore prima della lezione ti chiederemo di confermare la tua presenza. È molto importante rimanere in contatto affinché la lezione non venga annullata.",
            button: "Cos'altro?",
        },
        15: {
            title: "La lezione si svolgerà sulla nostra piattaforma 💻",
            typeInfo: "classroom",
            subtitle:
              "Riceverai un link e un codice univoco via WhatsApp ed email. Basta cliccare sul link, ti porterà direttamente alla lezione. Senza app aggiuntive e senza download.",
            button: "Ho capito ✅",
        },
    },
};
